<template>
  <div class="chatItem">
    {{ chatItem.nickname }} {{ chatItem.chatContext }}
  </div>
</template>

<script>
import { defaultAvatar } from "@/utils/constant";
export default {
  name: "ChatTip",
  props:{
    chatItem:{
      type: Object,
      default:{}
    }
  },
  data(){
    return{
      // defaultAvatar: defaultAvatar
    }
  }
}
</script>

<style lang="less" scoped>
.chatItem {
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;  /* 原20px */
  margin-left: 25px;   /* 原50px */
  font-size: 12px;     /* 原24px */
  font-weight: 500;
  line-height: 17px;  /* 原34px */
  color: #888;
  overflow-wrap: break-word;
  background-color: rgba(0,0,0,0.5);
  padding: 3px;
  border-radius: 3px;
}
</style>